import { render, staticRenderFns } from "./SevDeskOverview.vue?vue&type=template&id=6b795e4d&"
import script from "./SevDeskOverview.vue?vue&type=script&lang=js&"
export * from "./SevDeskOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports